<template>
    <div class="user" :class="{'bg-white': showAccountMenu}">
        <div class="avatar" @click="showAccountMenu = !showAccountMenu">
            <img :src="image" v-if="image"/>
            <div v-else>{{ avatarText }}</div>
        </div>
        <div class="account" v-if="showAccountMenu">
            <ul>
                <li>{{ account.name }}</li>
                <!--<li><a href="#" @click="logout">Sign out</a></li>-->
            </ul>
        </div>
    </div>
</template>

<script>
import { AuthService } from '../msal'

export default {
    data() {
        return {
            image: null,
            name: '',
            showAccountMenu: false,
        }
    },
    computed: {
        account() {
            return AuthService.getAccount()
        },
        avatarText() {
            var n = this.name.split(' '), out = 'X'
            if (n.length===2) {
                out = n[0].slice(0,1).toUpperCase()+n[1].slice(0,1).toUpperCase()
            } else if (n.length===1) {
                out = n[0].slice(0, 1).toUpperCase()
            }
            return out
        }
    },
    created() {
        AuthService.getUserPhoto()
        .then(async image => {
            if (image) {
                this.image = image
            } else {
                var account = await AuthService.getAccount()
                console.log('Avatar:', account.name)
                this.name = account.name
            }
        })
        .catch(err => {
            console.log('Created', err)
        })
    },
    methods: {
        logout: function() {
            AuthService.signOut()
        }
    }
}
</script>

<style>
.user:hover {
    cursor: pointer;
}
.avatar {
    justify-self: flex-end;
    width: 48px;
    height: 48px;
    padding: 8px;
}
.avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.avatar div {
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: purple;
    color: white;
    border-radius: 50%;
}
.account {
    position: absolute;
    padding: 10px 20px;
    right: 0;
    background: #fefefe;
    /* border: solid 1px #ccc; */
    border-radius: 2px;
    box-shadow: -1px 1px 5px #ddd;
}
.account ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.account a, a:visited {
    color: #005A9E
}
.account a {
    text-decoration: none;
    font-weight: bold;
    font-size: smaller;
}
.account a:hover {
    text-decoration: underline;
}
.bg-white {
    background:#fefefe;
}
</style>